
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.54 47.86h49.12M7.53 53.04h37.5M50.66 47.72a26.91 26.91 0 00-49.11.33v10.58h49.11z"}}),_c('path',{attrs:{"d":"M7.79 58.16v-9.72a21 21 0 0136.64-.21v10","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('rect',{attrs:{"x":"43.71","y":"18.8","width":"13.98","height":"3.83","rx":"1.92","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M56.67 18.69l1.79-3.78-3.61-5.63-8.31-.04-3.6 5.63 1.79 3.78M50.7 8.63V.37M53.13 22.14l3.17 36.49h-5.42M46.59 40.56l1.68-18.43M42.88 14.63h15"}})])
          )
        }
      }
    